import React from 'react';

import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import Table from '../../Shared/UI/Table/components/Table';
import Thead from '../../Shared/UI/Table/components/Thead';
import Tbody from '../../Shared/UI/Table/components/Tbody';
import Tr from '../../Shared/UI/Table/components/Tr';
import Th from '../../Shared/UI/Table/components/Th';
import Td from '../../Shared/UI/Table/components/Td';

import { useExternalJobBoardsState, useExternalJobBoardsActions } from './ExternalJobBoardsContext';

const PreviewLinkDataModal = () => {
  const externalJobBoardsState = useExternalJobBoardsState();
  const { closePreviewLinkDataModal } = useExternalJobBoardsActions();

  const externalJobBoard = externalJobBoardsState?.previewLinkDataExternalJobBoard;
  const linksPreview = externalJobBoard?.linksPreview;
  const linksPreviewedAt = externalJobBoard?.linksPreviewedAt;

  const hasLinks = linksPreview && linksPreview.length > 0;

  return (
    <StandardModal
      isOpen={externalJobBoardsState?.previewLinkDataModalIsOpen}
      contentLabel={'Preview Link Data'}
      onRequestClose={closePreviewLinkDataModal}
    >
      <PageTitle text={'Preview Link Data'} />
      {linksPreviewedAt && (
        <p>
          Last previewed: {new Date(linksPreviewedAt).toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            timeZoneName: 'short'
          })}
        </p>
      )}
      {hasLinks ? (
        <Table>
          <Thead>
            <Tr>
              <Th>Index</Th>
              <Th>Text</Th>
              <Th>URL</Th>
            </Tr>
          </Thead>
          <Tbody>
            {linksPreview.map((link) => (
              <Tr key={link.index}>
                <Td>{link.index}</Td>
                <Td>{link.text}</Td>
                <Td>
                  {link.url ? (
                    <a href={link.url} target="_blank" rel="noopener noreferrer">
                      {link.url.length > 60 ? `${link.url.substring(0, 60)}...` : link.url}
                    </a>
                  ) : (
                    '—'
                  )}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      ) : (
        <p>No previewed links currently available. Use "Refresh Previewed Links" to scrape link data for this board.</p>
      )}
    </StandardModal>
  );
};

export default PreviewLinkDataModal;
